import React from 'react';
import {Container, Grid} from '@material-ui/core';
import {
  TopNavBar,
  Footer
} from '../../components'
import {withRouter} from 'react-router-dom'
import Seo from "../../components/Seo";

function HomePage(props) {
  const onSearchClick = (item,category) => {
    props.history.push({
      pathname: '/result',
      state: {search: item , category: category}
    })
  }

  return (
    <>
      <Seo
        title="Privacy Policy"
        description="AgriLive's privacy policy."
        path="/privacyPage"
      />
      <TopNavBar onClick={onSearchClick}/>

      <Grid container alignItems='center' className=' after-navbar-container'>
            <Container component='main' maxWidth='md'>
                <ul>
                 <br/>
                   <br/>
                    <li>
                        <p>Google Sign-In is a secure authentication system that reduces the burden of login for your users, by enabling them to sign in with their Google Account—the same account you already use with Gmail, Play, and other Google services.</p>
                    </li>
                    <li>
                        <p>Google Sign-In is also your gateway to connecting with Google’s users and services in a secure manner. You get an the opportunity to pay with Google Pay, share with their Google-wide contacts, save a file to Drive, add an event to Calendar, and more. </p>
                    </li>
                    <li>
                        <p>We are Integrate Google’s user-centric APIs and services inside our app. We dont store your credentials and you are authenticated using google API service. </p>
                    </li>
                    <li>
                        <p><b>Do we store your google password?</b></p>
                    </li>
                    <li>
                        For authentication with google we use google api services and do not store your password. You can update your personal information for best alarms and alerts but you can not add your google passwords in system.
                    </li>
                    <li>
                    <b>Do we store your facebook password?</b>
                    </li>
                    <br/>
                    <li>For authentication with facebook we use google api services and do not store your password. You can update your personal information for best alarms and alerts but you can not add your google passwords in system.
                    </li>
                    <br/>
                    <li>You can email us at <u>termssupport@agrilivemarket.com</u> for more information.
                    </li>
                    <br/>
                    <li>
                    <b>How do we use your data?</b>
                    </li>
                    <br/>
                    <li>We only store your personal data in system which we agreed with you. We will only use Personal Data on the basis of a legal ground:
                    </li>
                    <br/>
                    <li><b>How do we share your data?</b>
                    </li>
                    <br/>
                    <li>We will never transfer, sell, make copies, or share any of your data stored by the application to third party services or companies unless strictly necessary to enable the application to function properly. Accordingly, personal data will be disclosed to third parties on a strictly limited 'need to know' basis where there is clear justification for transferring Personal Data - either because the Data Subject has consented to the transfer or because disclosure is required to perform a contract to which the Data Subject is a party, or for a legitimate purpose that does not infringe the Data Subject's fundamental rights, including the right to privacy (e.g. sharing in the context of a merger and acquisition operation
                    </li>
                    <div align="center">
                      <b>
                       <u>Terms and conditions</u>
                      </b>
                    </div>

                    <li>Securing your personal information and not sharing with any other is your sole responsbility. If your devices is stolen or hacked containing your personal information. We are not responsible for such incidents.
                    </li>

             </ul>
            </Container>
       </Grid>
        <Grid item lg={12} md={12}>
          <Footer/>
        </Grid>
    </>
  );
}

export default HomePage;
